<template>
  <div class="view-container">
    <component :is="layout"></component>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  components: {
    Default: () => import('@/pages/signup/landings/Default.vue'),
  },
  computed: {
    layout() {
      return `Default`
    },
  },
  async created() {
    await Promise.all([this.getMalls(), this.getMe()])
  },
  methods: {
    ...mapActions('mall', ['getMalls']),
    ...mapActions('auth', ['getMe']),
  },
}
</script>
